<template>
    <main class="common__page__box main__voice__bank__page">
        <div class="rlms-container">
            <section class="learner__assessments__filter__box voice__bank">
                <div class="back__btn">
                    <RouterLink
                        :to="{ name: 'LearnerVoiceBank', params: { organization: organizationId, learner: learnerId } }">
                        <span class="btn__icon">
                            <img :src="backBtnIcon" />
                        </span>
                        <span class="btn__text">Back</span>
                    </RouterLink>
                </div>
                <div class="main__title">
                    <h3 class="title">Test Item</h3>
                </div>
            </section>
            <section class="learner__data__content__box">
                <div class="inner__cover__box">
                    <div class="sidebar__section__box">
                        <div class="profile__widget__box">
                            <div class="user__profile__img">
                                <img :src="learnerIcon">
                            </div>
                            <h5 class="title">{{ learner?.firstname }} {{ learner?.lastname }}</h5>
                            <div class="user__personal__info">
                                <div class="info__box__wrapper">
                                    <label class="label">Date of Birth</label>
                                    <span class="location">{{ formatDate(learner?.dob) }}</span>
                                </div>
                            </div>
                            <div class="learner__edit__btn" v-if="learner?.is_owner || learner?.is_administrator">
                                <a href="javascript:void(0)" @click="showEditLearnerModal = true">
                                    <span class="btn__icon">
                                        <img :src="editIcon">
                                    </span>
                                    <span class="btn__text">Edit Learner</span>
                                </a>
                            </div>
                        </div>
                        <div class="btn__widget__box">
                            <div class="purple__solid__btn">
                                <RouterLink
                                    :to="{ name: 'LearnerVoiceBank', params: { organization: organizationId, learner: learnerId } }">
                                    View By Assessments</RouterLink>
                            </div>
                        </div>
                    </div>
                    <div class="main__data__content__box rlms-table" style="border: none;">
                        <table class="rlms-w-100">
                            <thead>
                                <tr style="border-bottom: 1px solid #bec0c4;">
                                    <th style="text-align:left;background: #fff;">
                                        <div class="rlms-flex rlms-justify-between">
                                            <span>Test Item</span>
                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;Assessments</span>
                                        </div>
                                    </th>
                                    <th v-for="(assessment, aIdx) in assessments" :key="assessment"
                                        style="text-align: center;background: #fff;">{{ assessments?.length - aIdx }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="question in questions" :key="question.id">
                                    <td style="border-bottom: none; width: 300px;">
                                        <div class="rlms-flex rlms-flex-col rlms-justify-start">
                                            <span><strong>{{ question.question }}</strong></span>
                                            <span>{{ formatConsonants(question.consonant) }}</span>
                                        </div>
                                    </td>
                                    <td v-for="assessment in assessments" :key="assessment"
                                        style="text-align: center;vertical-align: middle;border-bottom: none;width: 80px; min-width: 80px; max-width: 80px;">
                                        <div class="rlms-flex rlms-items-center rlms-justify-center">
                                            <a href="javascript:void(0)"
                                                @click="selectedItem = findAssessmentAttempt(assessment, question.id)">
                                                <img :src="playIcon"
                                                    v-if="findAssessmentAttempt(assessment, question.id)?.audio">
                                                <img :src="noPlayIcon" v-else>
                                            </a>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </section>
        </div>
        <AddEditLearnerModal v-if="showEditLearnerModal" @close="showEditLearnerModal = false;" @saved="init()"
            :organizationId="organizationId" :learner="learner" />
        <PlayAudioModal v-if="selectedItem" :item="selectedItem" @close="selectedItem = null" />
    </main>
</template>
<script setup>
import AddEditLearnerModal from '@/components/AddEditLearnerModal.vue';
import PlayAudioModal from '@/components/PlayAudioModal.vue';
import api from '@/services/axios';
import { useLoaderStore } from '@/stores/loader';
import { formatConsonants, formatDate } from '@/utils/format-helpers';
import { handleError } from '@/utils/handleError';
import { onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';
import backBtnIcon from '@/assets/images/back-btn-icon.png'
import learnerIcon from '@/assets/images/learner-icon.png'
import editIcon from '@/assets/images/edit.svg'
import playIcon from '@/assets/images/audio/transcribe/play.png'
import noPlayIcon from '@/assets/images/audio/transcribe/no-play.png'

const route = useRoute();
const organizationId = ref(Number(route.params.organization ?? 0));
const learnerId = ref(Number(route.params.learner ?? 0));
const learner = ref(null);
const loader = useLoaderStore();
const showEditLearnerModal = ref(false);
const questions = ref([]);
const assessments = ref([]);
const assessmentAudioAttempts = ref([]);
const selectedItem = ref(null);

onMounted(async () => {
    init();
});

const init = () => {
    showEditLearnerModal.value = false;
    fetchLearner();
}

const fetchLearner = async () => {
    try {
        loader.show();
        const { data } = await api.get(`/organizations/${organizationId.value}/learners/${learnerId.value}/testitem`);

        learner.value = data?.data?.learner;

        assessments.value = data?.data?.assessmentIds;
        questions.value = data?.data?.questions;
        assessmentAudioAttempts.value = data?.data?.assessmentAttempts;
    } catch (error) {
        handleError(error);
    } finally {
        loader.hide();
    }
};

const findAssessmentAttempt = (aid, qid) => {
    return (assessmentAudioAttempts.value || []).find(
        attempt => attempt.aid === aid && attempt.qid === qid
    );
};
</script>